import React, { useState } from 'react';
import { EFSectionData, EFQuestionData } from '../types/evalform';
import { QuestionType, OptionType } from '../types/evalform';
import PreviewQuestionCard from './PreviewQuestionCard';
import '../styles/components/SectionCard.css';

interface MomentItem {
  id: number;
  name: string;
  description?: string;
  category_id?: number;
}

interface MomentOperationInterface {
  id: number;
  name: string;
  description: string;
}

interface PreviewSectionCardProps {
  section: EFSectionData;
  sectionIndex: number;
  searchText?: string;
  moments?: MomentItem[];
  operations?: MomentOperationInterface[];
}

const PreviewSectionCard: React.FC<PreviewSectionCardProps> = ({
  section,
  sectionIndex,
  searchText,
  moments = [],
  operations = []
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const highlightText = (text: string) => {
    if (!searchText || !text) return text;
    
    const parts = text.split(new RegExp(`(${searchText})`, 'gi'));
    
    return parts.map((part, index) => {
      if (part.toLowerCase() === searchText.toLowerCase()) {
        return <mark key={index} className="search-highlight">{part}</mark>;
      }
      return part;
    });
  };

  return (
    <div className="section-card">
      <div 
        className="section-card-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="section-card-title">
          <h3>{highlightText(section.name)}</h3>
        </div>
        <div className="section-card-score preview-score">
          {section.points || 0}
        </div>
        <span className="material-icons">
          {isExpanded ? 'expand_less' : 'expand_more'}
        </span>
      </div>
      
      {isExpanded && (
        <div className="section-card-content">
          {section.questions.map((question, questionIndex) => {
            // Map EFQuestionData to PreviewQuestionCard props
            const questionType = question.type_id === QuestionType.MOMENT ? 'Moment' : 'Prompt';
            const optionType = question.option_type_id === OptionType.YES_NO ? 'YES_NO' : 
                              question.option_type_id === OptionType.GRADING ? 'GRADING' : 'MULTI_CHOICE';
            
            // Map moments for display
            const questionMoments = question.moments && question.moments.length > 0
              ? [...question.moments]
                  .sort((a, b) => (a.order || 0) - (b.order || 0))
                  .map(moment => {
                    const momentDetails = moments.find(m => m.id === moment.moment_id);
                    const operationDetails = operations.find(o => o.id === moment.operation_id);
                    
                    return {
                      id: moment.moment_id,
                      name: momentDetails?.name || 'Undefined Moment',
                      operation: operationDetails?.name || 'NONE'
                    };
                  })
              : undefined;

            // Map options to FormOption format
            const formOptions = (question.options || []).map(opt => ({
              id: opt.id || 0,
              order: opt.order,
              points: opt.points,
              is_fail_id: 0,
              description: opt.description,
              rated_option_id: null,
              rated_points: null,
              rated_remarks: null,
              is_reviewer_points: 0,
              reviewer_points: null,
              rating_status: '',
              is_selected: 0
            }));

            return (
              <PreviewQuestionCard
                key={question.id || questionIndex}
                id={question.id || questionIndex}
                questionNumber={questionIndex + 1}
                questionText={question.description}
                questionType={questionType}
                optionType={optionType}
                options={formOptions}
                points={question.points}
                evaluationId="0"
                prompt={question.prompt || ''}
                moments={questionMoments}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PreviewSectionCard;

